import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import {first} from "rxjs";
import {SelectedWorkspaceStore} from "../../stores/selected-workspace.store";
import { UserJourneyEvent, TrackModel, InternalTrackModel } from './user-journey.types';
import * as Sentry from '@sentry/angular';

@Injectable({
  providedIn: 'root',
})
export class MetricService {
  private baseUrl = environment.apiUrl;
  private sessionId: string;

  constructor(private http: HttpClient, private selectedWorkspaceStore: SelectedWorkspaceStore) {
    let sessionId = sessionStorage.getItem('user_journey_session_id');
    if (!sessionId) {
      sessionId = crypto.randomUUID();
      sessionStorage.setItem('user_journey_session_id', sessionId);
    }
    this.sessionId = sessionId;
  }

  track(trackBody: TrackModel) {
    // Добавляем "хлебную крошку" в Sentry для контекстуализации ошибок.
    Sentry.addBreadcrumb({
      category: 'user-journey',
      message: trackBody.name,
      level: 'info',
      data: {
        ...trackBody.payload,
        elementText: trackBody.elementText,
        elementValue: trackBody.elementValue,
      },
    });

    const internalTrack: InternalTrackModel = {...trackBody, sessionId: this.sessionId};
    this.http.post(`${this.baseUrl}/api/metric`, internalTrack).pipe(first()).subscribe();
  }
}
